import axios from "axios";
import { getTranslationsOriginDomain } from "../utilites";

const translationsApiUrl = `${`${process.env.REACT_APP_TRANSLATION_URL}.${getTranslationsOriginDomain()}` || 'https://translations.astrionaplay.com'}/api/v1/Translations`;

export async function getTranslations(applicationId, isoCode) {try {
        const response = await axios.get(translationsApiUrl, {
            params: {
                ApplicationId: applicationId,
                IsoCode: isoCode
            },
            headers: {
                Accept: 'text/plain'
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Request failed with status: ' + response.status);
        }
    } catch (error) {
        throw new Error('An error occurred: ' + error.message);
    }
}
